export default __webpack_public_path__ + "static/media/check.e91ea97d.svg";